/**
 * External Imports
 */
import { FC } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

/**
 * Internal Imports
 */
import FacilityAndUnitSettings from './FacilityAndUnitSettings';
import EmployeeRoundingSettings from './EmployeeRoundingSettings';

import { useUserRolesRef } from '../../services/UserRoles/userRoles';

const Account: FC<{}> = () => {
  const {
    isEmployeeRounder,
    isIlobRounder,
    isAnyValidationRounder,
    isNonSupportRounder,
    isSupportRounder,
    isTemplateConfigurator,
    isUserAdmin
  } = useUserRolesRef();

  return (
    <div data-testid="account-module">
      <div>
        <Routes>
          {/* TODO add back when notifications are managed in Orbit */}
          {/* <Route path="notifications" element="Notifications" /> */}
          {(isNonSupportRounder || isTemplateConfigurator || isUserAdmin) && (
            <Route
              path="facility-and-unit-settings"
              element={<FacilityAndUnitSettings />}
            />
          )}
          {(isEmployeeRounder ||
            isIlobRounder ||
            isSupportRounder ||
            isAnyValidationRounder) && (
            <Route path="employee-rounding-settings" element={<Outlet />}>
              <Route index element={<EmployeeRoundingSettings />} />
              <Route
                path=":empRoundSettingsTable"
                element={<EmployeeRoundingSettings />}
              />
            </Route>
          )}
          <Route
            path="*"
            element={
              <Navigate
                to={localStorage.getItem('orbitLastPath') || '/'}
                replace
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default Account;
